import { render, staticRenderFns } from "./Nueva-button.vue?vue&type=template&id=62c726f8&scoped=true"
import script from "./Nueva-button.vue?vue&type=script&lang=js"
export * from "./Nueva-button.vue?vue&type=script&lang=js"
import style0 from "./Nueva-button.vue?vue&type=style&index=0&id=62c726f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c726f8",
  null
  
)

export default component.exports